import { BlankSlate } from "@msuite/ui/blank-slate";
import { useTranslation } from "@msuite/ui/localization";

export function ModalLoadFailedContent() {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="flex-center h-[200px]">
			<BlankSlate
				withBorder={false}
				withBackground={false}
				label={t("general.content_not_loadable")}
			/>
		</div>
	);
}
